import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpService } from '../../shared/services/http.service';
import { GatewayId } from '../../site-gateway/models/gateway';
import { Site, SiteOID } from '../models/Site';

import { buildSiteFromApiResult } from './api/build-site-from-api-result';
import { SitesBatchApiResult } from './api/site-api-result.types';
import { SiteGateway } from './SiteGateway';

const SITE_ENDPOINT = '/v1/site';

@Injectable({ providedIn: 'root' })
export class HttpSiteGateway implements SiteGateway {
    private readonly httpService = inject(HttpService);

    getSite(siteOID: SiteOID): Observable<Site> {
        return this.httpService.get(`${SITE_ENDPOINT}/${siteOID}`).pipe(map(buildSiteFromApiResult));
    }

    getSiteByGatewayId(gatewayId: GatewayId): Observable<Site[]> {
        return this.httpService
            .post(`${SITE_ENDPOINT}/_batch`, { gatewayIds: [gatewayId] })
            .pipe(map(({ results }: SitesBatchApiResult) => results.map(buildSiteFromApiResult)));
    }

    getSitesBatch(siteOIDs: SiteOID[]): Observable<Site[]> {
        if (!siteOIDs || siteOIDs.length === 0) {
            return of([]);
        }

        return this.httpService
            .post(`${SITE_ENDPOINT}/_batch`, { siteOIDs })
            .pipe(map(({ results }: SitesBatchApiResult) => results.map(buildSiteFromApiResult)));
    }

    deleteInstallerSite(siteId: string): Observable<void> {
        return this.httpService.delete(`${SITE_ENDPOINT}/${siteId}`);
    }
}
